export default __webpack_public_path__ + "static/media/successgif.4efa143c.gif";